/**
 *
 */

var Headings = (function($) {
  function initHeadings() {
    // Array de frases
    const phrases = [
      "Craft Catering for Breakfast",
      "Craft Catering for Lunch",
      "Craft Catering for Breaks",
      "Craft Catering for Networking"
    ];

    const heading = document.querySelector(".home-hero__heading");
    let index = 0;

    function changeText() {
      // Cambiamos el texto de inmediato
      heading.textContent = phrases[index];
      index = (index + 1) % phrases.length;
    }

    // Lanzamos el cambio cada 2.5 segundos
    setInterval(changeText, 800);
  }

  function init() {
    // return early if no corresponding module present
    if (!$(".home-hero__heading").length) {
      return;
    }

    initHeadings();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Headings.init);
